<portal-modal-header
  [title]="'common.file.rejected' | translate"
  (onClose)="dismiss()"
  variant="warning"
></portal-modal-header>

<portal-modal-body>
  @if (rejectedFiles.files.length > 1) {
    <div>{{ 'common.file.rejected.description' | translate }}</div>
  }

  <portal-file-rejected-description
    [multiple]="rejectedFiles.files.length > 1"
    [rejectedFiles]="rejectedFiles"
  ></portal-file-rejected-description>
</portal-modal-body>

<portal-modal-footer [closeOnly]="true" (onCancel)="dismiss()"></portal-modal-footer>
